export default __webpack_public_path__ + "images/logo.5bad5f95789968ec691e85b8b9ea4f05.png";